module.exports = __webpack_public_path__ + "img/mockup-valores.ea6bcc2a.png";